import React from 'react'
import Icon from 'components/Icon'
import StyledFab from './StyledFab'

const Fab = ({ name, position = '', className, ...props }) => {
  const x = position && (position.match(/left|right/) || ['center'])[0]
  const y = position && (position.match(/top|bottom/) || ['center'])[0]
  const positionProps = position ? { position, x, y } : {}

  return (
    <StyledFab className={`Fab ${className}`} {...positionProps} {...props}>
      <Icon name={name} />
    </StyledFab>
  )
}

export default Fab
